import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let cache = null;

// Abbreviation dictionaries per sport, straight from the backend sport definitions.
const loadGlossaries = () => {
  if (!cache) {
    cache = fetch(`${API_URL}/api/sports`)
      .then((r) => (r.ok ? r.json() : { sports: [] }))
      .then((d) => Object.fromEntries((d.sports || []).map((s) => [s.key, s.glossary || {}])));
    cache.catch(() => { cache = null; });
  }
  return cache;
};

export function useSportGlossary(sport) {
  const [glossary, setGlossary] = useState({});
  useEffect(() => {
    let alive = true;
    loadGlossaries().then((all) => { if (alive) setGlossary(all[(sport || 'basketball').toLowerCase()] || {}); }).catch(() => {});
    return () => { alive = false; };
  }, [sport]);
  return glossary;
}
